import { setStore } from "@/util/store";
import {
  Login,
  WxLogin,
  GetPersonalInfo,
  GetUserTestMechanism,
  CheckApply,
} from "@/api/admin/login.js";
import { dateFormats } from "@/util/data.js";

const common = {
  state: {
    userInfo: {},
    userToken: "",
    userRole: 0,
    personalInfo: {},
    levels: [],
  },
  actions: {
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        Login(userInfo)
          .then((data) => {
            const list = data.data.result;
            if (data.data.success) {
              if (list.isSuccess) {
                commit("SET_USERIFNO", list.userData);
                if (list.userData.isverify) {
                  commit("SET_USERTOKEN", list.userData.userToken);
                  commit("SET_USERROLE", list.userData.usertype);
                }
              }
              resolve(list);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    wxLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        WxLogin(userInfo)
          .then((data) => {
            const list = data.data.result;
            if (data.data.success) {
              if (list.isSuccess) {
                commit("SET_USERIFNO", list.userData);
                if (list.userData.isverify) {
                  commit("SET_USERTOKEN", list.userData.userToken);
                  commit("SET_USERROLE", list.userData.usertype);
                }
              }
              resolve(list);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 退出
    loginOut({ commit }) {
      commit("SET_USERIFNO", {});
      commit("SET_USERTOKEN", "");
      commit("SET_USERROLE", 0);
      window.sessionStorage.clear();
      window.localStorage.clear();
    },
    // 获取用户信息
    GetPersonalInfo({ commit }, personalInfo) {
      if (personalInfo) {
        return new Promise((resolve, reject) => {
          if (common.state.userRole == 3) {
            GetUserTestMechanism(personalInfo)
              .then((data) => {
                const list = data.data.result;
                if (data.data.success) {
                  if (list.isSuccess) {
                    commit("SET_PERSONALINFO", list.userInfo);
                  }
                  resolve(list);
                }
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            GetPersonalInfo(personalInfo)
              .then((data) => {
                const list = data.data.result;
                if (data.data.success) {
                  if (list.isSuccess) {
                    if (list.userInfo) {
                      if (list.userInfo.birthday) {
                        list.userInfo.birthday = dateFormats(
                          new Date(list.userInfo.birthday)
                        ).substring(0, 11);
                      }
                    }
                    commit("SET_PERSONALINFO", list.userInfo);
                  }

                  resolve(list);
                }
              })
              .catch((error) => {
                reject(error);
              });
          }
        });
      }
    },
    // 报名接口检测
    GetCheckApply({ commit }, personalInfo) {
      return new Promise((resolve, reject) => {
        commit("SET_LEVELS", []);
        CheckApply(personalInfo)
          .then((data) => {
            const list = data.data.result;
            if (data.data.success) {
              if (list.isSuccess) {
                commit("SET_LEVELS", list.levels);
              } else {
                commit("SET_LEVELS", []);
              }
              resolve(list);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    SET_USERIFNO: (state, userInfo) => {
      state.userInfo = userInfo;
      setStore({
        name: "userInfo",
        content: userInfo,
        type: "session",
      });
    },
    SET_USERTOKEN: (state, userToken) => {
      state.userToken = userToken;
      setStore({
        name: "userToken",
        content: userToken,
        type: "session",
      });
    },
    SET_USERROLE: (state, userRole) => {
      state.userRole = userRole;
      setStore({
        name: "userRole",
        content: userRole,
        type: "session",
      });
    },
    SET_PERSONALINFO: (state, personalInfo) => {
      state.personalInfo = personalInfo;
      setStore({
        name: "personalInfo",
        content: personalInfo,
        type: "session",
      });
    },
    SET_LEVELS: (state, levels) => {
      state.levels = levels;
      setStore({
        name: "levels",
        content: levels,
        type: "session",
      });
    },
  },
};

export default common;
